export function formatAuthor(author) {
  if (!author) {
    return '';
  }

  const { firstName, lastName, email } = author;

  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }

  if (email) {
    return email;
  }

  return '';
}
